/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useIsAuthenticated } from '@azure/msal-react';
import React from 'react';
import { Navigate } from 'react-router-dom';

export const PrivateRoute = (props: any) => {
  const dataLogin = `${localStorage.getItem('user_login')}`;
  const isAuthenticated = JSON.parse(dataLogin)?.token;
  if (isAuthenticated) {
    return props.children;
  }
  return <Navigate to="/login" />;
};
